// extracted by mini-css-extract-plugin
module.exports = {"CenterLayout":"Layout_CenterLayout__2VS3r","MaxWidth600":"Layout_MaxWidth600__2P6u2"};